import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface TimelineDates {
  /** Start date (from API start_date or submission_starts_at). */
  start: Date | null;
  submissionStart: Date | null;
  submissionEnd: Date | null;
  evaluationEnd: Date | null;
}

@Component({
  selector: 'app-challenge-timeline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './challenge-timeline.component.html',
  styleUrl: './challenge-timeline.component.scss'
})
export class ChallengeTimelineComponent {
  @Input() timelineDates!: TimelineDates;
  @Input() variant: 'sidebar' | 'mobile' = 'sidebar';

  /** Format date in IST (Indian Standard Time). */
  formatTimelineDate(date: Date | null): string {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Asia/Kolkata'
    }).format(date).replace(/,/g, '');
  }

  getTimelineDotClass(date: Date | null, type: 'start' | 'submissionStart' | 'submissionEnd' | 'evaluationEnd'): string {
    if (!date) return 'challenge-timeline--dot-grey';
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    
    if (today > compareDate) {
      return 'challenge-timeline--dot-green';
    } else if (today.getTime() === compareDate.getTime()) {
      return 'challenge-timeline--dot-orange';
    } else {
      return 'challenge-timeline--dot-grey';
    }
  }

  /** True when the date is in the past (completed). Used to show date text in green. */
  isDateCompleted(date: Date | null): boolean {
    if (!date) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    return today > compareDate;
  }
}


